
import { getDataBase } from '@/db';
import FechaHora from '@/utils/FechaHora';
import { Plomero } from '@/Servicios/ControlErrores';

export default class ModificacionGeneracionLecturaDAL {

    async Insertar(datos) {       
    
        try {
            const db = await getDataBase();
            const tx = db.transaction('MODIFICACIONGENERACIONLECTURA ', 'readwrite');
            const store = tx.objectStore('MODIFICACIONGENERACIONLECTURA ');
            const loFechaHora = new FechaHora();

            const loModificacionGeneracionLectura = {
                // Datos ModificacionGeneracionLectura
                GeneracionFactura: datos.GeneracionFactura,
                Cliente: datos.Cliente,
                Usr: Plomero(),
                Glosa: datos.Glosa,
                Fecha: loFechaHora.getFecha(),
                Hora: loFechaHora.getHora(),
        
                // Datos GeneracionLectura
                CodigoUbicacion: datos.CodigoUbicacion,
                LecturaAnterior: datos.LecturaAnterior,
                LecturaActual: datos.LecturaActual,
                Consumo: datos.Consumo,
                MedidorAnormalidad: datos.MedidorAnormalidad,
                MediaAnterior: datos.MediaAnterior,
                Cobro: datos.Cobro,
                Media: datos.Media,
                ConsumoFacturado: datos.ConsumoFacturado,
                ConsumoDebito: datos.ConsumoDebito,
        
                // Datos GeneracionLecturaMovil
                FechaAnterior: datos.FechaAnterior,
                HoraAnterior: datos.HoraAnterior,
                Categoria: datos.Categoria,
                Medidor: datos.Medidor,
                TipoConsumo: datos.TipoConsumo,
                MedidorAnormalidad2: datos.MedidorAnormalidad2,
                AplicoMedia: datos.AplicoMedia,
                ConsuFactu: datos.ConsuFactu,
                AjusteConsumo: datos.AjusteConsumo,
                AjusteMonto: datos.AjusteMonto,
                DesviacionSignificativa: datos.DesviacionSignificativa,
                InspeccionRequerida: datos.InspeccionRequerida,
                Facturado: datos.Facturado,
                ValidoLectura: datos.ValidoLectura,
            };
        
            await store.add(loModificacionGeneracionLectura);
            await tx.done;

            return loModificacionGeneracionLectura;
        } catch (error) {
            console.error('Error en el metodo Insertar de dbIndex: ', error);
            throw error;
        }
    }


    // const laClientes = await store.getAll(tcCliente);
    // const laResult = [];
    // laClientes.forEach((loCliente)=>{
    //     if (loCliente.GeneracionFactura == tcGeneracionLectura) {
    //         laResult.push(loCliente); 
    //     }
    // });


    async GetIDBy(tcGeneracionFactura, tcCliente){
        try {
            const db = await getDataBase();
            const tx = db.transaction('MODIFICACIONGENERACIONLECTURA ', 'readonly');
            const store = tx.objectStore('MODIFICACIONGENERACIONLECTURA ');
            const index = store.index('Cliente');

            const laClientes = await index.getAll(String(tcCliente));            
            const laResult = laClientes.filter(loCliente => loCliente.GeneracionFactura == tcGeneracionFactura);
    
            await tx.done;
            return laResult;

        } catch (error) {
            console.error(error); //guardar en log movil
            throw new Error('Error al obtener ID por GeneracionFactura y Cliente: ' + error.message);
        }
    }
}